import performance from '@jira/platform__performance/src/performance.tsx';
import { CacheHitRatioReporter } from './CacheHitRatioReporter.tsx';
import type { CHRReporterSummary } from './CHRReporterSummary.types.tsx';
import { getSSRMark } from './getSSRMark.tsx';
/**
 * Collects and summarizes web resource loading performance data during the initial page load.
 * Returns a summary object or an empty object in case of no data or errors.
 */
export const getCHRInfo = ({ start }: { start: number }): CHRReporterSummary | {} => {
	// initial load only
	if (start !== 0) {
		return {};
	}
	const ssrMark = getSSRMark();
	const reporter = new CacheHitRatioReporter(ssrMark);
	try {
		// oxlint-disable-next-line typescript/consistent-type-assertions
		for (const entry of performance.getEntriesByType('resource') as PerformanceResourceTiming[]) {
			reporter.add(entry);
		}
		const chr = reporter.get();
		return chr === null
			? {}
			: {
					chr,
				};
	} catch (e: unknown) {
		return {};
	}
};
